import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { FormItem } from '@/components/Form'
import { TextInput } from './Compo'

const NubisDrive = ({ value, onChange, loading }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{marginBottom: 24}}>
        6. {t({ defaultMessage: "Nubis 空间上传" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <TextInput
        number="6.1"
        title={t({defaultMessage: "文本上传"})}
        value={value.text}
        name="nubisDrive.text"
        placeholder={t({defaultMessage: "例：Nubis 空间"})}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default NubisDrive